import { Button, StatusMessage } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';

import { AlertTriangle } from 'lucide-react';

/**
 * The request failed and trying again might work.
 *
 * `onRetry` must re-issue the failed request — never `window.location.reload()`.
 * A full reload inside the shell throws away the user's place, and `WidgetGrid`
 * defaults `onDashboardRetry` to exactly that, which is why the Overview tab
 * overrides it with a real retry.
 *
 * With no handler there is no button: an inert "Retry" is a worse lie than
 * admitting there is nothing to do.
 */
function ErrorState({ message, onRetry }) {
  const { t } = useTranslation('unified-profiles');

  return (
    <div data-testid="error-state" className="flex flex-1 flex-col items-center justify-center gap-6">
      <StatusMessage
        icon={AlertTriangle}
        title={t('states.error.title')}
        subtitle={message || t('states.error.subtitle')}
      />
      {onRetry ? (
        <Button variant="secondary" size="medium" onClick={onRetry}>
          {t('states.error.retry')}
        </Button>
      ) : null}
    </div>
  );
}

export default ErrorState;
